import { jsx } from 'react/jsx-runtime';
import styles from './Spinner3.js';

/** The spinner component is mostly used as a loading indicator which comes in multiple sizes, and width separately or inside elements such as buttons to improve the user experience whenever data is being fetched from your server. */
const Spinner = ({ size, borderWidth, variant = 'primary', state }) => (jsx("div", { "data-testid": "spinner", style: { width: `${size}px`, height: `${size}px`, borderWidth: `${borderWidth}px` }, className: styles.spinnerStyle(variant, state) }));

export { Spinner };
